import React from 'react'
import { useParams, Link } from 'react-router-dom'
import posts from './PostData'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import Seo from '../Seo'

function BlogPost() {
  const { id } = useParams()
  const post = posts.find((p) => p.id === parseInt(id))

  if (!post) return <div className="p-6">Post not found.</div>

  const postDescription = post.preview || 'Read this Halal Wealth blog article on halal saving and ethical investing.'

  return (
    <div className="body-bg pt-[140px] pb-20 px-6 sm:px-24">
      <Seo
        title={`${post.title} | Halal Wealth Blog`}
        description={postDescription}
        pathname={`/blog/${post.id}`}
      />
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-md p-8">
        <img
          src={post.image}
          alt={post.title}
          className="w-full h-70 object-cover mb-6 rounded"
        />
        <p className="text-sm text-gray-500 mb-2">{post.date}</p>
        <h1 className="text-3xl font-bold text-text-color1 mb-4">{post.title}</h1>

        <div className="prose max-w-none text-gray-800 break-words whitespace-normal leading-relaxed
                        [&>p]:mb-4 [&>h2]:mt-6 [&>h2]:mb-3 [&>h3]:mt-4 [&>h3]:mb-2">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {post.content}
          </ReactMarkdown>
        </div>

        <Link
          to="/blog"
          className="mt-6 inline-block text-primary-color hover:underline"
        >
          ← Back to Blog
        </Link>
      </div>
    </div>
  )
}

export default BlogPost
